import { Stashboard, useTheme } from '@springbig/shared';
import { HStack, VStack, Box } from 'native-base';
import { Caption } from '~/shared/Typography';
import React, { useState } from 'react';
import { useAppNavigate } from '~/pages';
import { SpIcon } from '~/shared/Icon';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import PaginationDot from 'react-native-animated-pagination-dot';
import { Keyboard, Mousewheel, Pagination } from 'swiper';
import { Button, Card } from '~/shared/Theme';
import { format, formatDistanceToNow } from 'date-fns';

type MessagesProps = {
    data: Array<Stashboard>;
};

export const Messages = ({
    data,
}: MessagesProps) => {

    const { navigate, params } = useAppNavigate();
    const [activeSlide, setActiveSlide] =
        useState(0);

    const {
        primary,
        radius_md,
    } = useTheme();

    return (
        <VStack space={2}>
            <HStack justifyContent={'space-between'} alignItems={'center'}>
                <HStack space={2} alignItems={'center'}>
                    <SpIcon icon={faComment} color={primary} size={24} />
                    <Caption text={'homepage.messages.checkLatest'} />
                </HStack>
                <Button
                    variant={'text'}
                    modifier={'small'}
                    text={'homepage.messages.viewAll'}
                    onPress={() => navigate(`w/${params.wallet_id}/messages`)}
                />
            </HStack>

            { data.length > 0 &&
                <Card p={0} pb={4}>
                    <Swiper
                        spaceBetween={0}
                        navigation={false}
                        keyboard={true}
                        modules={[Pagination, Mousewheel, Keyboard]}
                        style={{
                            pointerEvents: 'auto',
                            width: '100%',
                        }}
                        onSlideChange={(swiper) => {

                            setActiveSlide(swiper.snapIndex);
                        }}
                    >
                        { data.map((item, index) => (

                            <SwiperSlide
                                style={{
                                    width: '100%',
                                }}
                                key={index}
                            >
                                <VStack
                                    alignItems={'center'}
                                    rounded={radius_md}
                                    space={2}
                                    w={'full'}
                                    flex={1}
                                >
                                    { item.stashboard_media.length > 0 ? (
                                        <Box position="relative" w="100%">
                                            <Box
                                                p={2}
                                            >
                                                <Caption
                                                    text={'homepage.messages.sentAt'}
                                                    textValues={{
                                                        time: format(new Date(item.sent_at), 'MMM d, yyyy h:mm a'),
                                                        ago: formatDistanceToNow(new Date(item.sent_at), { addSuffix: true })
                                                    }}
                                                    fontSize={'xs'}
                                                    textAlign={'center'}
                                                />
                                            </Box>
                                            <img
                                                src={item.stashboard_media[0]?.result_url}
                                                style={{
                                                    width: '100%',
                                                    borderRadius: radius_md,
                                                }}
                                            />
                                        </Box>
                                    ) : (
                                        <Caption
                                            text={'homepage.messages.sentAt'}
                                            textValues={{
                                                time: format(new Date(item.sent_at), 'MMM d, yyyy h:mm a'),
                                                ago: formatDistanceToNow(new Date(item.sent_at), { addSuffix: true })
                                            }}
                                            fontSize={'xs'}
                                            textAlign={'center'}
                                        />
                                    )}

                                    { item.sms_content &&
                                      <Caption px={2}>
                                          { item?.sms_content }
                                      </Caption>
                                    }

                                    <Button
                                        onPress={() => navigate(`w/${params.wallet_id}/messages/${item._key}`)}
                                        text={'homepage.messages.viewMessage'}
                                    />
                                </VStack>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Card>
            }


            { data.length > 1 &&
                <VStack alignItems="center">
                    <PaginationDot
                        activeDotColor={primary}
                        curPage={activeSlide}
                        maxPage={data.length > 3 ? 3 : data.length}
                    />
                </VStack>
            }
        </VStack>
    );
};
